<template>
    <div
        class="input-textarea flex flex-row items-center rounded-xl border-grey-light border relative transition-colors max-w-full cursor-pointer hover:border-grey"
        @click="focusInput"
        :class="isLoading"
    >
        <div class="absolute top-3 left-3 flex-shrink-0">
            <slot name="icon" v-if="$slots.icon != null"> </slot>
        </div>

        <textarea
            ref="input"
            class="bg-transparent border-none py-2 mr-1 pr-1 w-full rounded-xl scrollbar"
            :class="
                $slots.icon != null
                    ? 'pl-9 ' + heightClass
                    : 'pl-3 ' + heightClass
            "
            :id="id"
            :name="name"
            :type="type"
            :value="modelValue"
            :autocomplete="'off'"
            @input="updateInput"
            @change="changeInput"
            @focus="focus"
        />

        <label
            :for="id"
            class="text-grey absolute transition-all px-1 left-2"
            :class="[
                modelValue && modelValue != ''
                    ? labelClass + ' -top-3 text-sm'
                    : 'top-2 text-md',
                $slots.icon != null && (!modelValue || modelValue == '')
                    ? 'left-8'
                    : '',
            ]"
            >{{ label }}</label
        >
    </div>
</template>

<script>
import { computed, defineComponent, ref } from "vue";
import { useStore } from "vuex";
import { HELPER_TYPES, STORE_TYPES } from "../../store/types";
export default defineComponent({
    components: {},
    name: "InputText",
    props: {
        id: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: false,
        },
        modelValue: {
            type: String,
            default: "",
        },
        heightClass: { type: String, default: "" },
        label: {
            type: String,
            default: "",
        },
        labelClass: {
            type: String,
            default: "",
        },
        type: {
            type: String,
            default: "text",
        },
    },
    emits: ["update:modelValue", "change", "focus"],
    setup(props, ctx) {
        const store = useStore();
        /**
         * refs
         */
        const input = ref();
        /**
         * functions
         */
        function focusInput() {
            if (input.value) {
                input.value.focus();
            }
        }
        /**
         * emits
         */
        function updateInput(event) {
            const newValue = event.target.value;
            ctx.emit("update:modelValue", newValue);
        }
        function changeInput() {
            ctx.emit("change", props.modelValue);
        }
        function focus(event) {
            ctx.emit("focus", event);
        }

        /**
         *  Computed
         */

        const isLoading = computed(() => {
            const loadingIds =
                store.getters[
                    `${STORE_TYPES.HELPERS}/${HELPER_TYPES.GET_LOADING_IDS}`
                ];
            let loading = loadingIds.find((loadingId) => loadingId == props.id);

            return loading ? "border-loading" : "";
        });
        return {
            //refs
            input,
            //functions
            focusInput,
            //emits
            updateInput,
            changeInput,
            focus,
            //computed

            isLoading,
        };
    },
});
</script>
<style lang="scss">
.input-textarea textarea {
    overflow-y: auto;
}
.input-textarea:focus-within {
    @apply border-grey;
}
</style>
